import { useMemo } from "react";

import { useAllSaasDestinations } from "./useAllSaasDestinations";
import useArrayOfDestinations from "./useArrayOfDestinations";
import { SaaSDestination } from "@/destinations/destinations";

export function useDestinationConfigSaasDestinationPairs() {
  const destinations = useArrayOfDestinations();
  const saasDestinations = useAllSaasDestinations();

  return useMemo(() => {
    return destinations
      .map((d) => ({
        destinationConfig: d,
        saasDestination:
          d.name === "Function"
            ? ({
                key: "Function",
                name: "Function Destinations",
                slug: "Function",
                destinationCategories: [],
              } as unknown as SaaSDestination)
            : (saasDestinations[d.type_slug] as SaaSDestination),
      }))
      .filter((t) => !!t.saasDestination);
  }, [destinations, saasDestinations]);
}

export type DestinationConfigSaasDestinationPair = ReturnType<
  typeof useDestinationConfigSaasDestinationPairs
>[number];
